import React, { useState, useEffect } from "react";
import { Grid, Backdrop, CircularProgress, Fab } from "@material-ui/core";
import useStyles from "./styles";
import PageTitle from "../../components/PageTitle";
import { Typography } from "../../components/Wrappers";
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router-dom";
import { signOut, useUserDispatch } from "../../context/UserContext";
import EmailIcon from '@material-ui/icons/Email';
import Companies from '../../images/icon/Companies.png';
import New from '../../images/icon/New.png';
import FinalInterview from '../../images/icon/FinalInterview.png';
import DocumentCollected from '../../images/icon/DocumentCollected.png';
import FinalInterviewComplete from '../../images/icon/FinalInterviewComplete.png';
import InterviewScheduled from '../../images/icon/InterviewScheduled.png';
import Joined from '../../images/icon/Joined.png';
import Offered from '../../images/icon/Offered.png';
import SalaryBreakup from '../../images/icon/SalaryBreakup.png';
import ScheduleInterview from '../../images/icon/ScheduleInterview.png';
import YetToJoin from '../../images/icon/YetToJoin.png';
import WorkFlow from '../../images/gallery/RefoWorkFlow.png'
import WorkFlowRC from '../../images/gallery/RefoWorkFlowRc.jpg'
import AdminDashboard from "./dashboardItems/AdminDashboard";
import FreelancerDashboard from "./dashboardItems/FreelancerDashboard";
import RecruiterDashboard from "./dashboardItems/RecruiterDashboard";
import HiringManagerDashboard from "./dashboardItems/HiringManagerDashboard";
import VendorDashboard from "./dashboardItems/VendorDashboard";


export default function Dashboard(props) {

  var classes = useStyles();
  const history = useHistory();
  var userDispatch = useUserDispatch();

  const [loader, setLoader] = useState(false);
  var [count, setCount] = useState([]);
  const token = localStorage.getItem('token');
  const decode = jwtDecode(token);
  const initialCounts = {
    status301_count: 0,
    status303_count: 0,
    status3031_count: 0,
    status304_count: 0,
    status3041_count: 0,
    status305_count: 0,
    status306_count: 0,
    status307_count: 0,
    status308_count: 0,
    status3081_count: 0,
    status309_count: 0,
  }
  const [candidateCounts, setCandidateCounts] = useState(initialCounts);


  useEffect(() => {
    setLoader(true);
    var decode = jwtDecode(token);

    var url = "";
    if (decode.role === "SUPERADMIN") {
      url = `${process.env.REACT_APP_SERVER}superAdmin/superAdminDashboard`
    } else if (decode.role === "ADMIN") {
      url = `${process.env.REACT_APP_SERVER}admin/adminDashboard`
    } else if (decode.role === "CLIENTCOORDINATOR") {
      url = `${process.env.REACT_APP_SERVER}CC/ccDashboard`
    } else {
      url = `${process.env.REACT_APP_SERVER}recruiter/recuriterDashboard`
    }

    axios({
      method: 'post',
      url: url,
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },

    })
      .then(function (response) {
        if (response.data.status === true) {
          setCandidateCounts(response.data.data.newcounts)
          setCount(response.data.data);
          setLoader(false);

        }
      })
      .catch(function (error) {
        console.log(error);
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          signOut(userDispatch, props.history)
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userDispatch])


  return (
    <>

      {decode.role === "ADMIN" ?
        <Grid container direction="row" spacing={2} >
          <Grid item xs={12} className={classes.flexCenter}>
            <img src={decode.companyType === "COMPANY" ? WorkFlow : WorkFlowRC} alt="workflow" width="82%" />
          </Grid>
        </Grid>
        : ""}
      <Grid container direction="row" spacing={2}>
        <Grid item xs={6}>   <PageTitle title={decode.role === "SUPERADMIN" ? "Dashboard" : "Live Status"} />  </Grid>
        <Grid item xs={6}> </Grid>
      </Grid>

      <Grid container spacing={2} columns={16}  >
        {decode.role === "SUPERADMIN" ?
          <Grid item lg={2} xl={2} md={3} sm={4} xs={12} onClick={() => { history.push("/app/admin") }}>
            <div className={classes.blue}>
              <p className={classes.grid_title}>Companies</p>
              <div className={classes.visitsNumberContainer}>
                <Grid container item  >
                  <Grid item xs={7} className={classes.M10}>
                    <Typography size="xl" weight="medium" noWrap className={classes.count}>
                      {count.admin_count}
                    </Typography>
                  </Grid>
                  <Grid item xs={5} className={classes.M10}    >
                    <Fab className={classes.blueIcon} aria-label="dashboard">
                      <img className={classes.w25} src={Companies} alt="Companies" />
                    </Fab>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>

          : decode.role === "ADMIN" ?
            <AdminDashboard candidateCounts={candidateCounts} />
            : decode.role === "CLIENTCOORDINATOR" ?
              <HiringManagerDashboard candidateCounts={candidateCounts} />
              : decode.role === "RECRUITER" ?
                <RecruiterDashboard candidateCounts={candidateCounts} />
                : decode.role === "SUBVENDOR" ?
                  <FreelancerDashboard candidateCounts={candidateCounts} />
                  :
                  <VendorDashboard candidateCounts={candidateCounts} />
        }
      </Grid>

      <Backdrop className={classes.backdrop} open={loader}  >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
